<template>
  <div class="success-case">
    <SuccessCaseContent1/>
  </div>
</template>

<script>
  import SuccessCaseContent1 from '@/pages/success-case-content/SuccessCaseContent1.vue'
  export default {
    name: 'SuccessCase',
    components:{SuccessCaseContent1}
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/SuccessCase.vue